/* eslint-disable max-len */
/* eslint no-confusing-arrow: ["error", {allowParens: true}] */

import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import {
    Text,
    IconChevronRight,
    IconError,
    IconSuccess,
    spaceMixin,
    token,
} from '@zillow/constellation';


// vars
const THEME_VALIDATION = 'props => props.theme && props.theme.ns';
const panelHeight = '90px';

export const StyledLink = styled(Link)`
    /* fixes visual bug when Card is wrapped with Link/Anchor */
    display: block;

    border-bottom: 1px solid ${token('colors.gray300')};

    &:last-child {
        border-bottom: none;
    }
`;

export const StyledPropertyPanel = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    height: ${panelHeight};
    padding: 8px 16px;
`;

/* override internal breakpoints */
export const StyledPropertyPanelTitle = styled(Text)`
    margin-bottom: ${spaceMixin(0.5)};
    font-weight: 600;
    line-height: 15px;
`;

export const StyledPropertyPanelContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 2;
`;

export const StyledPropertyPanelIconContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: center;
`;

export const StyledCountBadge = styled.div`
    margin-right: ${spaceMixin(1)};
`;

export const StyledIconSuccess = styled(IconSuccess)`
    width: 20px;
    height: 20px;

    ${props => THEME_VALIDATION && css`
        margin-right: ${spaceMixin(1)};
        color: ${props.theme.ns().colors.green500};
    `};
`;

export const StyledIconError = styled(IconError)`
    width: 22px;
    height: 22px;

    ${props => THEME_VALIDATION && css`
        margin-right: ${spaceMixin(1)};
        color: ${props.theme.ns().colors.red400};
    `};
`;

export const StyledIconChevronRight = styled(IconChevronRight)`
    align-self: center;
    color: ${props => THEME_VALIDATION && props.theme.ns().colors.blue400};
`;
